// User roles
export const USER_ROLE_ANONYMOUS = "anonymous";
export const USER_ROLE_USER = "user";
export const USER_ROLE_JANITOR = "janitor";
export const USER_ROLE_MODERATOR = "moderator";
export const USER_ROLE_OFFICER = "officer";
export const USER_ROLE_ADMIN = "admin";

// User statuses
export const USER_STATUS_INACTIVE = "inactive";
export const USER_STATUS_ACTIVE = "active";
export const USER_STATUS_BANNED = "banned";

export const USER_STATUSES = [
  USER_STATUS_INACTIVE,
  USER_STATUS_ACTIVE,
  USER_STATUS_BANNED,
];

// Breakpoints
export const DEVICE_MOBILE = 768;
export const DEVICE_TABLET = 990;

// File Sizes
export const BYTE = 1;
export const KIBIBYTE = 1024 * BYTE;
export const MEBIBYTE = 1024 * KIBIBYTE;

// Upload File Size Limits
export const UPLOAD_VIDEO_FILE_DURATION = 20; //seconds
export const UPLOAD_VIDEO_FILE_RESOLUTION = 960 * 720; //pixels
export const UPLOAD_VIDEO_FILE_SIZE = 300 * MEBIBYTE;
export const UPLOAD_VIDEO_FILE_SIZE_PREMIUM = 600 * MEBIBYTE;
export const UPLOAD_IMAGE_FILE_SIZE = 15 * MEBIBYTE;

// Upload File Formats
export const UPLOAD_VIDEO_FILE_FORMAT = {
  'video/mp4': ['.mp4'],
};
export const UPLOAD_IMAGE_FILE_FORMAT = {
  'image/jpeg': ['.jpeg', '.jpg'],
  'image/png': ['.png'],
  'image/gif': ['.gif'],
  'image/webp': ['.webp'],
  'video/webm': ['.webm'],
};

// Client-side upload validation (file size, duration, resolution and format)
// Set the DISABLE_UPLOAD_VALIDATION env variable (to any non-empty value) to skip it
export const DISABLE_UPLOAD_VALIDATION = Boolean(process.env.DISABLE_UPLOAD_VALIDATION);

// External links to purchase premium days
// AMOUNT=Days, COST=USD, URL=checkout url
export const PREMIUM_PURCHASE_LINKS = [
  { amount: 30, cost: 5, url: "https://iwara.shop/checkout/?add-to-cart=126" },
  { amount: 60, cost: 10, url: "https://iwara.shop/checkout/?add-to-cart=127" },
  { amount: 90, cost: 15, url: "https://iwara.shop/checkout/?add-to-cart=128" },
];

// External links to purchase wura
// AMOUNT=Wura, COST=USD, URL=checkout url
export const WURA_PURCHASE_LINKS = [
  { amount: 10000, cost: 11, url: "https://iwara.shop/checkout/?add-to-cart=13382" },
  { amount: 25000, cost: 27.50, url: "https://iwara.shop/checkout/?add-to-cart=13383" },
  { amount: 50000, cost: 55, url: "https://iwara.shop/checkout/?add-to-cart=13384" },
  { amount: 100000, cost: 110, url: "https://iwara.shop/checkout/?add-to-cart=13385" },
];

// Default values
export const DEFAULT_AVATAR = "/images/default-avatar.jpg";
export const DEFAULT_BACKGROUND = "/images/default-background.jpg";

// Ratings
export const RATING_GENERAL = "general";
export const RATING_ECCHI = "ecchi";

// Times
export const SECONDS_PER_MINUTE = 60;
export const SECONDS_PER_HOUR = SECONDS_PER_MINUTE * 60;
export const SECONDS_PER_DAY = SECONDS_PER_HOUR * 24;
export const SECONDS_PER_MONTH = SECONDS_PER_DAY * 30;
export const SECONDS_PER_YEAR = SECONDS_PER_MONTH * 12;

// Counts
export const FORUM_POSTS_PER_PAGE = 32; // This needs to be in sync with backend

// Revive
export const REVIVE_HOST = process.env.REVIVE_HOST;
export const REVIVE_PATH = process.env.REVIVE_PATH;
export const REVIVE_UNIQUE_ID = process.env.REVIVE_UNIQUE_ID;
export const SHOW_ZONE_NAMES_KEY = "show-zone-names";

// Content zones
export const FORUM_PAGE_CONTENT_IDS = [
  "forum_section_list_wide_1",
  "forum_section_list_wide_2",
  "forum_section_list_wide_3",
];

export const FORUM_SECTION_CONTENT_IDS = [
  "forum_section_wide_1",
  "forum_section_wide_2",
];

export const FORUM_THREAD_CONTENT_IDS = [
  "forum_thread_wide_1",
  "forum_thread_wide_2",
];

export const HOME_PAGE_CONTENT_IDS = [
  "home_list_wide_1",
  "home_list_wide_2",
  "home_list_wide_3",
];

export const IMAGE_DETAIL_PAGE_CONTENT_IDS = [
  "image_detail_wide_1",
  "image_detail_wide_2",
  "image_detail_tall_1",
  "image_detail_tall_2",
  "image_detail_tall_3",
];

export const IMAGE_LIST_PAGE_CONTENT_IDS = [
  "image_list_wide_1",
  "image_list_tall_1",
  "image_list_tall_2",
  "image_list_tall_3",
  "image_list_tall_4",
];

export const POST_DETAIL_PAGE_CONTENT_IDS = [
  "post_detail_wide_1",
  "post_detail_wide_2",
  "post_detail_tall_1",
  "post_detail_tall_2",
  "post_detail_tall_3",
];

export const PROFILE_PAGE_CONTENT_IDS = [
  "profile_wide_1",
  "profile_wide_2",
  "profile_tall_1",
];

export const SEARCH_PAGE_CONTENT_IDS = [
  "search_wide_1",
];

export const VIDEO_DETAIL_PAGE_CONTENT_IDS = [
  "video_detail_wide_1",
  "video_detail_wide_2",
  "video_detail_tall_1",
  "video_detail_tall_2",
  "video_detail_tall_3",
];

export const VIDEO_LIST_PAGE_CONTENT_IDS = [
  "video_list_wide_1",
  "video_list_tall_1",
  "video_list_tall_2",
  "video_list_tall_3",
  "video_list_tall_4",
];

export const ALL_CONTENT_IDS = [
  ...FORUM_PAGE_CONTENT_IDS,
  ...FORUM_SECTION_CONTENT_IDS,
  ...FORUM_THREAD_CONTENT_IDS,
  ...HOME_PAGE_CONTENT_IDS,
  ...IMAGE_DETAIL_PAGE_CONTENT_IDS,
  ...IMAGE_LIST_PAGE_CONTENT_IDS,
  ...POST_DETAIL_PAGE_CONTENT_IDS,
  ...PROFILE_PAGE_CONTENT_IDS,
  ...SEARCH_PAGE_CONTENT_IDS,
  ...VIDEO_DETAIL_PAGE_CONTENT_IDS,
  ...VIDEO_LIST_PAGE_CONTENT_IDS,
];
